import { render, staticRenderFns } from "./SubscriptionEndedPage.vue?vue&type=template&id=80032f94&"
import script from "./SubscriptionEndedPage.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionEndedPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports